<div class="eiq-textarea__container">
  @if (label() || hint()) {
    <span class="fs__sm fw__500 label">
      {{ label() }} <span class="fs__xs caption">{{ hint() }}</span>
    </span>
  }

  <mat-form-field appearance="outline" class="eiq-textarea__field" [attr.aria-labelled]="label()" [subscriptSizing]="'dynamic'">
    <textarea
      matInput
      cdkTextareaAutosize
      [attr.data-testid]="testId() ? testId() + '-textarea' : null"
      [cdkAutosizeMinRows]="minRows()"
      [cdkAutosizeMaxRows]="maxRows()"
      autocomplete="off"
      [style.resize]="resize$() ? 'vertical' : 'none'"
      [rows]="rows() ?? minRows()"
      [required]="required()"
      [placeholder]="placeholder()"
      [formControl]="control"
      [value]="currentValue"
      (input)="setValue($event)"
      (keyup.enter)="keyupEnter.emit()"
    ></textarea>
    @if (max() > 0) {
      <mat-hint class="eiq-textarea__max-length-hint">Chars left: {{ currentValue | charactersLeft: max() }}</mat-hint>
    }
    <ng-container matSuffix>
      <ng-content select="[slot=suffix]"></ng-content>
    </ng-container>
    @if (showError()) {
      <mat-error>
        <eiq-validation-text [formCtrl]="control"></eiq-validation-text>
      </mat-error>
    }
  </mat-form-field>
</div>
